<mat-card class="forget-password-card">
  <mat-card-header>
    <mat-card-title>{{ 'application.name-supervision' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'forget-password.sub-title' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()" style="margin: 20px 20px 0 20px;">
    <mat-card-content class="forget-password-card-content">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'forget-password.new-password' | translate }}</mat-label>
        <mat-icon matPrefix>lock</mat-icon>
        <input matInput [type]="hide ? 'password' : 'text'" placeholder="{{ 'label.password' | translate }}"
          formControlName="newPassword" autocomplete="off">
        <button type=button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions class="forget-password-card-action">
      <button mat-raised-button color="primary" type="button" (click)="onBackClick()"><mat-icon>undo</mat-icon>{{ 'button.back' | translate }}</button>
      <button mat-raised-button color="primary"><mat-icon>send</mat-icon>{{ 'button.send' | translate }}</button>
    </mat-card-actions>
  </form>
</mat-card>